import { render, staticRenderFns } from "./GeneralInfoBanner.vue?vue&type=template&id=4939389b&scoped=true&"
import script from "./GeneralInfoBanner.vue?vue&type=script&lang=ts&"
export * from "./GeneralInfoBanner.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInfoBanner.vue?vue&type=style&index=0&id=4939389b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939389b",
  null
  
)

export default component.exports